import { configureStore } from "@reduxjs/toolkit";
import profileReducer from "./profileSlice";
import paymentReducer from './paymentSlice';

export const store = configureStore({
  reducer: {
    profiles: profileReducer,
    payment: paymentReducer,
  },
});
